import React from 'react';
import styled from 'styled-components';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

import {
  Container,
  HeadingTextContainer,
  GridInformationContainer,
  DocumentList,
  Item,
  ExtraInformation,
  InputGroupContainer,
  NameContainer,
  PhoneContainer,
} from '../steps/GatherDocuments/GatherDocuments.styles';

import {
  Icon,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@polichat/flamboyant';

import channelAddWabaClassicModalImage from './channelAddWabaClassicModalImage.svg';
import Illustration from '../../../../../assets/images/illustrations/documentation-step-channel.svg';

const ModalStyled = styled(Modal)`
  .modal-content {
    overflow-y: auto;
    padding: 0;
    border-radius: 1rem !important;
    max-width: 628px;
  }
  .modal-header {
    padding: 0;
    background-color: #fafafa;
    border-radius: 1rem !important;
  }
  .modal-body {
    margin-bottom: 0;
    font-size: 15px;
  }
  .modal-footer {
    margin-top: -38px;
    justify-content: space-evenly !important;
    font-size: 13px;
  }
  button {
    max-width: 200px;
  }
`;

const ExternalLink = styled.a`
  text-decoration: none;
  color: #20EFE5;
`;

const ChannelAddWabaClassicModal = ({
  isOpen,
  handleCloseModal,
  handleProccessClassicNext,
  handleProccessNewNext,
}) => {
  // Traduções
  const facebookAnalysisText = useGlotaT('spa.certification.facebookAnalysisText');
  const documentSuggestionsText = useGlotaT('spa.certification.documentSuggestionsText');
  const cnpjCard = useGlotaT('spa.certification.documents.cnpjCard');
  const socialContract = useGlotaT('spa.certification.documents.socialContract');
  const operatingLicense = useGlotaT('spa.certification.documents.operatingLicense');
  const companyLicense = useGlotaT('spa.certification.documents.companyLicense');
  const creditReport = useGlotaT('spa.certification.documents.creditReport');
  const commercialTax = useGlotaT('spa.certification.documents.commercialTax');
  const phoneBill = useGlotaT('spa.certification.documents.phoneBill');
  const utilityBill = useGlotaT('spa.certification.documents.utilityBill');
  const extraInformationText = useGlotaT('spa.certification.extraInformationText');
  return (
    <ModalStyled isOpen={isOpen} toggle={handleCloseModal}>
      <ModalHeader>
        <img src={channelAddWabaClassicModalImage} />
      </ModalHeader>
      <ModalBody>
        <p>
          {facebookAnalysisText}{' '}
          <strong>
            {documentSuggestionsText}
          </strong>
        </p>

        <DocumentList>
          <p>
            <Item>
              <Icon icon="poli-icon pi-finish-fill" color="#20EFE5" size={24} />
              <span>{cnpjCard}</span>
            </Item>
            <Item>
              <Icon icon="poli-icon pi-finish-fill" color="#20EFE5" size={24} />
              <span>{socialContract}</span>
            </Item>
            <Item>
              <Icon icon="poli-icon pi-finish-fill" color="#20EFE5" size={24} />
              <span>{operatingLicense}</span>
            </Item>
            <Item>
              <Icon icon="poli-icon pi-finish-fill" color="#20EFE5" size={24} />
              <span>
                {companyLicense}
              </span>
            </Item>
            <Item>
              <Icon icon="poli-icon pi-finish-fill" color="#20EFE5" size={24} />
              <span>
                {creditReport}
              </span>
            </Item>
            <Item>
              <Icon icon="poli-icon pi-finish-fill" color="#20EFE5" size={24} />
              <span>{commercialTax}</span>
            </Item>
            <Item>
              <Icon icon="poli-icon pi-finish-fill" color="#20EFE5" size={24} />
              <span>{phoneBill}</span>
            </Item>
            <Item>
              <Icon icon="poli-icon pi-finish-fill" color="#20EFE5" size={24} />
              <span>{utilityBill}</span>
            </Item>{' '}
          </p>
        </DocumentList>
      </ModalBody>
      <ModalFooter>
        <p>
          {extraInformationText}
        </p>
      </ModalFooter>
    </ModalStyled>
  );
};
export default ChannelAddWabaClassicModal;
